import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const FilingName = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="generalInfo.filingName"
      control={control}
      rules={{ validate: Validators.required.field }}
      render={({ field }) => (
        <FF2
          required
          field={field}
          label={'Filing Name'}
          input={(props) => <TextInput data-qa="filingName" autoFocus {...props} />}
        />
      )}
    />
  )
}
